import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  image: string;
  rating: number;
  year: number;
  tags: string[];
  isHot?: boolean;
}

export default function VideoCard({ id, title, image, rating, year, tags, isHot }: VideoCardProps) {
  return (
    <div className="group relative bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer">
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={image}
          alt={`${title} - 蓝莓视频高清在线观看`}
          title={`${title} - 蓝莓视频推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
            热门
          </span>
        )}

        <div className="absolute top-2 right-2 flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-foreground-950/60 text-background-50">
          <i className="ri-star-fill text-accent-400 text-xs"></i>
          <span className="text-xs font-medium">{rating}</span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 mb-1.5 whitespace-nowrap overflow-hidden text-ellipsis">
          {title}
        </h3>
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-foreground-500">{year}</span>
          <div className="flex gap-1">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 rounded text-[10px] bg-secondary-100 text-secondary-700 whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}